<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              v-on:click="setActiveTab"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Importar OFX
            </a>
          </li>
          <li class="nav-item" v-if="transacoes.length > 0">
            <a
              class="nav-link"
              :class="{ disabled: !form.id_banco }"
              v-on:click="setActiveTab"
              data-tab="1"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Lançamentos ({{ transacoes.length }})
            </a>
          </li>
        </ul>
      </div>

      <div class="card-body">
        <b-tabs class="hide-tabs" v-model="tabIndex">
          <!-- ABA 0 — UPLOAD OFX -->
          <b-tab active>
            <b-row>
              <b-col md="6">
                <b-form-group label="Conta Bancária" label-for="banco_busca">
                  <div class="banco-typeahead" v-click-outside="fecharDropdownBanco">
                    <div class="input-group">
                      <b-form-input
                        id="banco_busca"
                        v-model="bancoBusca"
                        @input="onBancoBuscaInput"
                        @focus="bancoDropdownAberto = true"
                        autocomplete="off"
                        placeholder="Digite para buscar a conta bancária..."
                        :state="form.id_banco ? true : (bancoBusca && !form.id_banco ? false : null)"
                      />
                      <div class="input-group-append" v-if="form.id_banco">
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          @click="limparBanco"
                          v-b-tooltip.hover="'Limpar seleção'"
                        >✕</button>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="form.id_banco ? true : (bancoBusca && !form.id_banco ? false : null)">
                      Selecione uma conta bancária válida da lista.
                    </b-form-invalid-feedback>
                    <div
                      v-if="bancoDropdownAberto && bancos.length > 0"
                      class="banco-typeahead__dropdown"
                    >
                      <div
                        v-for="b in bancos"
                        :key="b.id_banco"
                        class="banco-typeahead__option"
                        @mousedown.prevent="selecionarBanco(b)"
                      >
                        <span class="font-weight-bold">{{ b.nome }}</span>
                        <small class="text-muted ml-2">Ag: {{ b.agencia }} / Cc: {{ b.conta }}</small>
                      </div>
                    </div>
                    <div
                      v-if="bancoDropdownAberto && bancoBusca && bancos.length === 0"
                      class="banco-typeahead__dropdown"
                    >
                      <div class="banco-typeahead__empty">Nenhuma conta encontrada.</div>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Dropzone de arquivo OFX -->
            <b-row>
              <b-col md="6">
                <div
                  class="ofx-dropzone"
                  :class="{ 'ofx-dropzone--active': isDragging }"
                  @dragover.prevent="isDragging = true"
                  @dragleave.prevent="isDragging = false"
                  @drop.prevent="onFileDrop"
                  @click="$refs.fileInput.click()"
                >
                  <input
                    ref="fileInput"
                    type="file"
                    accept=".ofx,.OFX"
                    hidden
                    @change="onFileChange"
                  />
                  <div v-if="!arquivoNome" class="text-center text-muted">
                    <FileUpload :size="40" class="mb-2" />
                    <p class="mb-0 font-weight-bold">
                      Clique ou arraste o arquivo OFX aqui
                    </p>
                    <small>Formatos aceitos: .ofx</small>
                  </div>
                  <div v-else class="text-center">
                    <FileCheck :size="40" class="mb-2 text-success" />
                    <p class="mb-0 font-weight-bold text-success">
                      {{ arquivoNome }}
                    </p>
                    <small class="text-muted">
                      Clique para trocar o arquivo
                    </small>
                  </div>
                </div>
              </b-col>
            </b-row>

            <!-- Resumo do OFX após parse -->
            <b-row v-if="ofxResumo" class="mt-4">
              <b-col md="8">
                <b-card class="border">
                  <h6 class="font-weight-bold mb-3">
                    Resumo do arquivo OFX
                  </h6>
                  <b-row>
                    <b-col md="4">
                      <small class="text-muted d-block">Banco (OFX)</small>
                      <span class="font-weight-bold">
                        {{ ofxResumo.bankId || "-" }}
                      </span>
                    </b-col>
                    <b-col md="4">
                      <small class="text-muted d-block">Conta (OFX)</small>
                      <span class="font-weight-bold">
                        {{ ofxResumo.acctId || "-" }}
                      </span>
                    </b-col>
                    <b-col md="4">
                      <small class="text-muted d-block">
                        Total de lançamentos
                      </small>
                      <span class="font-weight-bold text-primary">
                        {{ transacoes.length }}
                      </span>
                    </b-col>
                    <b-col md="4" class="mt-3">
                      <small class="text-muted d-block">Data início</small>
                      <span class="font-weight-bold">
                        {{ ofxResumo.dtStart || "-" }}
                      </span>
                    </b-col>
                    <b-col md="4" class="mt-3">
                      <small class="text-muted d-block">Data fim</small>
                      <span class="font-weight-bold">
                        {{ ofxResumo.dtEnd || "-" }}
                      </span>
                    </b-col>
                    <b-col md="4" class="mt-3">
                      <small class="text-muted d-block">Saldo final</small>
                      <span class="font-weight-bold">
                        R$ {{ numberToReal(ofxResumo.ledgerBal || 0, 2) }}
                      </span>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>

            <!-- Botão processar -->
            <b-row class="mt-4" v-if="transacoes.length > 0">
              <b-col>
                <button
                  @click="avancarParaLancamentos"
                  class="btn btn-info font-weight-bold mr-2"
                >
                  Ver lançamentos
                </button>
              </b-col>
            </b-row>
          </b-tab>

          <!-- ABA 1 — LANÇAMENTOS (duas colunas / drag-and-drop) -->
          <b-tab>
            <!-- Barra de progresso + ações -->
            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap" style="gap:12px">
              <div style="min-width:260px; flex:1">
                <div class="d-flex justify-content-between mb-1">
                  <small class="text-muted font-weight-bold">Progresso de conciliação</small>
                  <small :class="getTextVariant(percentualConcluido)" class="font-weight-bold">
                    {{ conciliadosCount }} / {{ transacoes.length }} — {{ percentualConcluido }}%
                  </small>
                </div>
                <b-progress
                  :value="percentualConcluido"
                  :max="100"
                  :variant="getProgressVariant(percentualConcluido)"
                  height="12px"
                  show-progress
                />
              </div>
              <div class="d-flex align-items-center" style="gap:8px">
                <b-form-input
                  v-model="buscaLancamento"
                  placeholder="Buscar..."
                  size="sm"
                  style="width:160px"
                />
                <b-form-select v-model="filtroLancamento" size="sm" style="width:130px">
                  <b-form-select-option value="">Todos OFX</b-form-select-option>
                  <b-form-select-option value="pendente">Pendentes</b-form-select-option>
                  <b-form-select-option value="conciliado">Conciliados</b-form-select-option>
                  <b-form-select-option value="ignorado">Ignorados</b-form-select-option>
                </b-form-select>
                <button
                  @click="salvarConciliacao"
                  class="btn btn-primary font-weight-bold btn-sm"
                  :disabled="isSaving"
                >
                  <b-spinner small v-if="isSaving" class="mr-1" />
                  Salvar Conciliação
                </button>
              </div>
            </div>

            <!-- Duas colunas -->
            <div class="conciliacao-grid">
              <!-- ── COLUNA OFX ── -->
              <div class="conc-col">
                <div class="conc-col-header conc-col-header--ofx">
                  <span class="font-weight-bold">Extrato OFX</span>
                  <span class="badge badge-light ml-2">{{ lancamentosOFXPendentes.length }} pendentes</span>
                </div>
                <div class="conc-col-body">
                  <div
                    v-if="lancamentosOFXPendentes.length === 0"
                    class="text-center text-muted py-5"
                  >
                    <Check :size="32" class="text-success mb-2" />
                    <p class="mb-0">Todos conciliados!</p>
                  </div>
                  <div
                    v-for="(trn, idx) in lancamentosOFXPendentes"
                    :key="'ofx-' + idx"
                    class="ofx-card"
                    :class="{ 
                      'ofx-card--dragging': draggedOfx === trn,
                      'ofx-card--sugerido': trn._sugeridoSistema
                    }"
                    draggable="true"
                    @dragstart="onDragStart(trn, $event)"
                    @dragend="onDragEnd"
                  >
                    <div class="d-flex justify-content-between align-items-start">
                      <div style="flex:1; min-width:0">
                        <div class="d-flex align-items-center mb-1" style="gap:4px">
                          <span :class="getTipoClass(trn.trnType)" style="font-size:8px; padding:2px 4px">
                            {{ getTipoLabel(trn.trnType) }}
                          </span>
                          <small class="text-muted" style="font-size:9px">{{ formatDate(trn.dtPosted) }}</small>
                          <span v-if="trn._sugeridoSistema" class="badge badge-warning" style="font-size:7px; padding:2px 4px">
                            ✓ Sugerido
                          </span>
                        </div>
                        <div class="ofx-card__memo">{{ trn.memo || "—" }}</div>
                        <small class="text-muted" style="font-size:8px">ID: {{ trn.fitId }}</small>
                        <div v-if="trn._criarMovimentacao" class="mt-1">
                          <span class="badge badge-info" style="font-size:7px; padding:2px 4px">+ Criar lançamento</span>
                          <span v-if="trn._novoLancamento" class="text-muted ml-1" style="font-size:8px">{{ trn._novoLancamento.descricao }}</span>
                        </div>
                        <div v-if="trn._sugeridoSistema && trn._sugestaoCompleta" class="mt-1">
                          <small class="badge badge-light" style="font-size:8px">
                            <strong>Sistema:</strong> {{ trn._sugeridoSistema }}
                            <span v-if="trn._sugestaoCompleta.sistema?.documento">
                              (Doc: {{ trn._sugestaoCompleta.sistema.documento }})
                            </span>
                          </small>
                        </div>
                      </div>
                      <div class="ml-2 text-right">
                        <div
                          class="font-weight-bolder"
                          :class="trn.trnAmt >= 0 ? 'text-success' : 'text-danger'"
                          style="font-size:12px; white-space:nowrap"
                        >
                          R$ {{ numberToReal(Math.abs(trn.trnAmt), 2) }}
                        </div>
                        <button
                          @click="marcarIgnorado(trn)"
                          class="btn btn-xs btn-link text-muted p-0 mt-1"
                          style="font-size:8px"
                          v-b-tooltip.hover="'Ignorar'"
                        >
                          Ignorar
                        </button>
                        <button
                          v-if="!trn._criarMovimentacao && trn.status === 'pendente'"
                          @click="abrirModalNovoLancamento(trn)"
                          class="btn btn-xs btn-link text-info p-0 mt-1"
                          style="font-size:8px"
                          v-b-tooltip.hover="'Criar lançamento financeiro'"
                        >
                          <PlusCircle :size="10" class="mr-1" />Criar
                        </button>
                        <button
                          v-if="trn._criarMovimentacao"
                          @click="cancelarNovoLancamento(trn)"
                          class="btn btn-xs btn-link text-danger p-0 mt-1"
                          style="font-size:8px"
                        >
                          ✕ Cancelar criação
                        </button>
                      </div>
                    </div>
                    <div class="ofx-card__drag-hint">
                      <ArrowRight :size="12" class="mr-1" />Arraste para conciliar
                    </div>
                  </div>

                  <!-- Ignorados (colapsados) -->
                  <div v-if="transacoesIgnoradas.length > 0" class="mt-2">
                    <div
                      class="text-muted font-weight-bold cursor-pointer"
                      style="font-size:10px"
                      @click="showIgnorados = !showIgnorados"
                    >
                      {{ showIgnorados ? '▼' : '▶' }} {{ transacoesIgnoradas.length }} ignorados
                    </div>
                    <div v-if="showIgnorados">
                      <div
                        v-for="(trn, idx) in transacoesIgnoradas"
                        :key="'ign-' + idx"
                        class="ofx-card ofx-card--ignored mt-2"
                      >
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <small class="text-muted" style="font-size:9px">{{ formatDate(trn.dtPosted) }}</small>
                            <div style="font-size:11px">{{ trn.memo }}</div>
                          </div>
                          <div class="d-flex align-items-center" style="gap:4px">
                            <span class="text-muted" style="font-size:11px">
                              R$ {{ numberToReal(Math.abs(trn.trnAmt), 2) }}
                            </span>
                            <button
                              @click="marcarPendente(trn)"
                              class="btn btn-xs btn-link p-0 text-warning"
                              style="font-size:8px"
                            >Reativar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ── COLUNA SISTEMA ── -->
              <div class="conc-col">
                <div class="conc-col-header conc-col-header--sistema">
                  <span class="font-weight-bold">Lançamentos do Sistema</span>
                  <span class="badge badge-light ml-2">{{ lancamentosSistemaDisponiveis.length }} disponíveis</span>
                  <div class="ml-auto d-flex align-items-center" style="gap:6px">
                    <button
                      @click="showFiltrosSistema = !showFiltrosSistema"
                      class="btn btn-xs btn-link p-0 text-white"
                      v-b-tooltip.hover="showFiltrosSistema ? 'Ocultar filtros' : 'Mostrar filtros para buscar lançamentos por tipo e período'"
                    >
                      <FilterVariant :size="14" />
                    </button>
                    <button
                      @click="fetchLancamentosSistema"
                      class="btn btn-xs btn-link p-0 text-white"
                      :disabled="isLoadingSistema"
                      v-b-tooltip.hover="'Recarregar lançamentos do sistema'"
                    >
                      <Refresh :size="14" />
                    </button>
                  </div>
                </div>

                <!-- Painel de filtros do sistema (colapsável) -->
                <div v-if="showFiltrosSistema" class="sistema-filtros">
                  <div class="d-flex flex-wrap" style="gap:6px; align-items:flex-end">
                    <div style="flex:1; min-width:90px">
                      <label style="font-size:9px; margin-bottom:1px; color:#555">Tipo</label>
                      <b-form-select v-model="filtroSistemaTipo" size="sm" style="font-size:11px">
                        <b-form-select-option value="">Todos</b-form-select-option>
                        <b-form-select-option value="receber">A Receber</b-form-select-option>
                        <b-form-select-option value="pagar">A Pagar</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div style="flex:1; min-width:100px">
                      <label style="font-size:9px; margin-bottom:1px; color:#555">De</label>
                      <b-form-input
                        v-model="filtroSistemaInicio"
                        type="date"
                        size="sm"
                        style="font-size:11px"
                      />
                    </div>
                    <div style="flex:1; min-width:100px">
                      <label style="font-size:9px; margin-bottom:1px; color:#555">Até</label>
                      <b-form-input
                        v-model="filtroSistemaFim"
                        type="date"
                        size="sm"
                        style="font-size:11px"
                      />
                    </div>
                    <button
                      @click="fetchLancamentosSistema"
                      class="btn btn-sm btn-success font-weight-bold"
                      :disabled="isLoadingSistema"
                      style="height:28px; font-size:11px"
                    >
                      Buscar
                    </button>
                  </div>
                </div>

                <div class="conc-col-body">
                  <div v-if="isLoadingSistema" class="text-center py-4">
                    <b-spinner variant="primary" small />
                    <small class="d-block text-muted mt-1">Carregando...</small>
                  </div>

                  <div
                    v-if="!isLoadingSistema && lancamentosSistemaDisponiveis.length === 0"
                    class="text-center text-muted py-5"
                  >
                    <p class="mb-0">Nenhum lançamento disponível para o período.</p>
                  </div>

                  <div
                    v-for="(lan, idx) in lancamentosSistemaDisponiveis"
                    :key="'sis-' + idx"
                    class="sistema-card"
                    :class="{
                      'sistema-card--over': dropTargetSistema === lan,
                      'sistema-card--conciliado': lan._conciliado,
                    }"
                    @dragover.prevent="dropTargetSistema = lan"
                    @dragleave="dropTargetSistema = null"
                    @drop.prevent="onDrop(lan)"
                  >
                    <!-- Conciliado -->
                    <div v-if="lan._conciliado" class="sistema-card__match">
                      <div class="d-flex justify-content-between align-items-start">
                        <div style="flex:1">
                          <div class="d-flex align-items-center mb-1" style="gap:4px">
                            <span class="badge badge-success" style="font-size:8px; padding:2px 4px">✓ Conciliado</span>
                            <small class="text-muted" style="font-size:9px">{{ formatDate(lan.data) }}</small>
                          </div>
                          <div class="font-weight-bold" style="font-size:11px">{{ lan.descricao }}</div>
                          <div v-if="lan.data_vencimento" class="text-muted" style="font-size:9px">
                            Venc: <strong>{{ formatDate(lan.data_vencimento) }}</strong>
                          </div>
                          <div v-if="lan.documento" class="text-muted" style="font-size:9px">
                            Doc: <strong>{{ lan.documento }}</strong>
                          </div>
                          <div class="mt-1 p-1 rounded" style="background:#f0f9f0; font-size:9px">
                            <span class="text-muted">OFX: </span>
                            <span class="font-weight-bold">{{ lan._conciliado.memo }}</span>
                            <span class="text-muted ml-1">({{ formatDate(lan._conciliado.dtPosted) }})</span>
                          </div>
                          <!-- Plano de Contas (editável) -->
                          <div class="mt-1" style="font-size:10px">
                            <label class="text-muted" style="display:block; margin-bottom:2px; font-size:10px">Plano de Contas:</label>
                            <div class="plano-contas-typeahead" v-click-outside="() => fecharDropdownPlanoContas(lan.id)">
                              <b-form-input
                                :ref="'planoInput' + lan.id"
                                :value="planoContasBuscaAtual[lan.id] || planosContas.find(p => p.id === lan.id_plano_contas)?.descricao || ''"
                                @input="(val) => onPlanoContasBuscaInput(lan, val)"
                                @focus="(e) => { 
                                  lancamentoEditando = lan;
                                  $nextTick(() => {
                                    e.target.select();
                                  });
                                  onPlanoContasBuscaInput(lan, '');
                                }"
                                autocomplete="off"
                                placeholder="Buscar plano de contas..."
                                size="sm"
                              />
                              <div
                                v-if="planoContasDropdownAberto[lan.id] && planosContasFiltrados[lan.id] && planosContasFiltrados[lan.id].length > 0"
                                class="plano-contas-dropdown"
                              >
                                <div
                                  v-for="p in planosContasFiltrados[lan.id].slice(0, 10)"
                                  :key="p.id"
                                  class="plano-contas-option"
                                  @mousedown.prevent="() => {
                                    alterarPlanoConta(lan, p.id);
                                    $set(planoContasBuscaAtual, lan.id, p.descricao);
                                    fecharDropdownPlanoContas(lan.id);
                                  }"
                                >
                                  <span class="font-weight-bold" style="font-size:12px">{{ p.descricao }}</span>
                                </div>
                              </div>
                              <div
                                v-if="planoContasDropdownAberto[lan.id] && planoContasBuscaAtual[lan.id] && (!planosContasFiltrados[lan.id] || planosContasFiltrados[lan.id].length === 0)"
                                class="plano-contas-dropdown"
                              >
                                <div class="plano-contas-empty">Nenhum plano encontrado.</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="text-right ml-2">
                          <div
                            class="font-weight-bolder"
                            :class="getValorClassPorTipo(lan.tipo)"
                            style="font-size:12px; white-space:nowrap"
                          >
                            R$ {{ numberToReal(Math.abs(lan.valor), 2) }}
                          </div>
                          <button
                            @click="desfazerConciliacao(lan)"
                            class="btn btn-xs btn-link text-danger p-0 mt-1"
                            style="font-size:8px"
                          >
                            Desfazer
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Disponível para conciliar -->
                    <div v-else>
                      <div class="d-flex justify-content-between align-items-center">
                        <div style="flex:1; min-width:0">
                          <div class="d-flex align-items-center gap-1 mb-1">
                            <small class="text-muted" style="font-size:9px">{{ formatDate(lan.data) }}</small>
                            <span v-if="lan._sugeridoOfx" class="badge badge-warning" style="font-size:7px; padding:2px 4px">
                              ✓ Sugerido
                            </span>
                          </div>
                          <div class="font-weight-bold mt-1" style="font-size:11px">{{ lan.descricao }}</div>
                          <div class="d-flex align-items-center" style="gap:6px">
                            <small class="text-muted" style="font-size:9px">{{ lan.tipo || "" }}</small>
                            <small v-if="lan.data_vencimento" class="text-muted" style="font-size:9px">
                              • Venc: <strong>{{ formatDate(lan.data_vencimento) }}</strong>
                            </small>
                          </div>
                          <div v-if="lan.documento" class="text-muted" style="font-size:9px; margin-top:2px">
                            Doc: <strong>{{ lan.documento }}</strong>
                          </div>
                          <div v-if="lan._sugeridoOfx" class="mt-1" style="font-size:8px">
                            <small class="badge badge-light">
                              Corresponde a OFX: {{ lan._sugeridoOfx }} ({{ Math.round(lan._confiancaSugestaoOfx * 100) }})
                            </small>
                          </div>
                          <!-- Plano de Contas Select -->
                          <div class="mt-1" style="font-size:10px">
                            <label class="text-muted" style="display:block; margin-bottom:2px; font-size:10px">Plano de Contas:</label>
                            <div class="plano-contas-typeahead" v-click-outside="() => fecharDropdownPlanoContas(lan.id)">
                              <b-form-input
                                :ref="'planoInput' + lan.id"
                                :value="planoContasBuscaAtual[lan.id] || planosContas.find(p => p.id === lan.id_plano_contas)?.descricao || ''"
                                @input="(val) => onPlanoContasBuscaInput(lan, val)"
                                @focus="(e) => { 
                                  lancamentoEditando = lan;
                                  $nextTick(() => {
                                    e.target.select();
                                  });
                                  onPlanoContasBuscaInput(lan, '');
                                }"
                                autocomplete="off"
                                placeholder="Buscar plano de contas..."
                                size="sm"
                              />
                              <div
                                v-if="planoContasDropdownAberto[lan.id] && planosContasFiltrados[lan.id] && planosContasFiltrados[lan.id].length > 0"
                                class="plano-contas-dropdown"
                              >
                                <div
                                  v-for="p in planosContasFiltrados[lan.id].slice(0, 10)"
                                  :key="p.id"
                                  class="plano-contas-option"
                                  @mousedown.prevent="() => {
                                    alterarPlanoConta(lan, p.id);
                                    $set(planoContasBuscaAtual, lan.id, p.descricao);
                                    fecharDropdownPlanoContas(lan.id);
                                  }"
                                >
                                  <span class="font-weight-bold" style="font-size:12px">{{ p.descricao }}</span>
                                </div>
                              </div>
                              <div
                                v-if="planoContasDropdownAberto[lan.id] && planoContasBuscaAtual[lan.id] && (!planosContasFiltrados[lan.id] || planosContasFiltrados[lan.id].length === 0)"
                                class="plano-contas-dropdown"
                              >
                                <div class="plano-contas-empty">Nenhum plano encontrado.</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="font-weight-bolder ml-2"
                          :class="getValorClassPorTipo(lan.tipo)"
                          style="font-size:12px; white-space:nowrap"
                        >
                          R$ {{ numberToReal(Math.abs(lan.valor), 2) }}
                        </div>
                      </div>
                      <div class="sistema-card__drop-hint" v-if="dropTargetSistema === lan">
                        <ArrowDownBold :size="12" class="mr-1" /> Solte aqui para conciliar
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pares conciliados (resumo) -->
            <div v-if="conciliadosCount > 0" class="mt-4">
              <div
                class="text-muted font-weight-bold cursor-pointer mb-2"
                style="font-size:13px"
                @click="showConciliados = !showConciliados"
              >
                {{ showConciliados ? '▼' : '▶' }} {{ conciliadosCount }} par(es) conciliado(s)
              </div>
              <div v-if="showConciliados" class="conciliados-list">
                <!-- Pares completos OFX ↔ Sistema -->
                <div
                  v-for="(par, idx) in paresConciliados"
                  :key="'par-' + idx"
                  class="conciliado-row"
                >
                  <div class="conciliado-row__ofx">
                    <small class="text-muted">{{ formatDate(par.ofx.dtPosted) }}</small>
                    <div style="font-size:12px">{{ par.ofx.memo }}</div>
                    <span
                      :class="par.ofx.trnAmt >= 0 ? 'text-success' : 'text-danger'"
                      class="font-weight-bold"
                      style="font-size:12px"
                    >R$ {{ numberToReal(Math.abs(par.ofx.trnAmt), 2) }}</span>
                  </div>
                  <div class="conciliado-row__arrow">⟺</div>
                  <div class="conciliado-row__sis">
                    <small class="text-muted">{{ formatDate(par.sistema.data) }}</small>
                    <div style="font-size:12px">{{ par.sistema.descricao }}</div>
                    <span
                      :class="getValorClassPorTipo(par.sistema.tipo)"
                      class="font-weight-bold"
                      style="font-size:12px"
                    >R$ {{ numberToReal(Math.abs(par.sistema.valor), 2) }}</span>
                  </div>
                  <button
                    @click="desfazerPar(par)"
                    class="btn btn-xs btn-outline-danger ml-2"
                    style="white-space:nowrap; height:28px"
                  >Desfazer</button>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <div class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <router-link
              class="btn btn-clean font-weight-bold"
              :to="{ name: 'conciliacaoBancariaLista' }"
            >
              Voltar
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Criar novo lançamento financeiro -->
    <b-modal
      id="modal-novo-lancamento-create"
      title="Criar Lançamento Financeiro"
      cancel-title="Cancelar"
      :busy="isConfirmandoLancamento"
      :ok-disabled="isConfirmandoLancamento"
      @ok="confirmarNovoLancamento"
      @cancel="trnSelecionada = null"
    >
      <template #modal-ok>
        <b-spinner small v-if="isConfirmandoLancamento" class="mr-1" />
        {{ isConfirmandoLancamento ? 'Salvando...' : 'Confirmar' }}
      </template>
      <b-form v-if="trnSelecionada">
        <b-row class="mb-3">
          <b-col>
            <small class="text-muted">Tipo:</small>
            <span class="badge" :class="novoLancamento.tipo === 'E' ? 'badge-success' : 'badge-danger'" style="font-size:13px">
              {{ novoLancamento.tipo === 'E' ? 'Receita' : 'Despesa' }}
            </span>
          </b-col>
        </b-row>
        <b-form-group label="Descrição" label-for="nl-descricao">
          <b-form-input
            id="nl-descricao"
            v-model="novoLancamento.descricao"
            placeholder="Descrição do lançamento"
          />
        </b-form-group>
        <b-row>
          <b-col md="6">
            <b-form-group label="Data" label-for="nl-data">
              <b-form-input
                id="nl-data"
                type="date"
                v-model="novoLancamento.data"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Valor (R$)" label-for="nl-valor">
              <b-form-input
                id="nl-valor"
                v-model="novoLancamento.valor"
                type="number"
                step="0.01"
                min="0"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Fornecedor (se for Despesa) -->
        <b-form-group v-if="novoLancamento.tipo === 'S'" label="Fornecedor" label-for="nl-fornecedor">
          <div class="fornecedor-typeahead-modal" v-click-outside="fecharDropdownFornecedor">
            <b-form-input
              id="nl-fornecedor"
              v-model="fornecedorBusca"
              @input="onFornecedorBuscaInput"
              @focus="fornecedorDropdownAberto = true"
              autocomplete="off"
              placeholder="Buscar fornecedor..."
            />
            <div
              v-if="fornecedorDropdownAberto && fornecedores.length > 0"
              class="plano-contas-dropdown"
            >
              <div
                v-for="f in fornecedores.slice(0, 10)"
                :key="f.id_pessoa"
                class="plano-contas-option"
                @mousedown.prevent="selecionarFornecedor(f)"
              >
                <div class="d-flex justify-content-between">
                  <span class="font-weight-bold" style="font-size:12px">{{ f.nome }}</span>
                  <span class="text-muted" style="font-size:10px">{{ f.cnpj_cpf }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="fornecedorDropdownAberto && fornecedorBusca && fornecedores.length === 0"
              class="plano-contas-dropdown"
            >
              <div class="plano-contas-empty">Nenhum fornecedor encontrado.</div>
            </div>
          </div>
        </b-form-group>

        <!-- Cliente (se for Receita) -->
        <b-form-group v-if="novoLancamento.tipo === 'E'" label="Cliente" label-for="nl-cliente">
          <div class="cliente-typeahead-modal" v-click-outside="fecharDropdownCliente">
            <b-form-input
              id="nl-cliente"
              v-model="clienteBusca"
              @input="onClienteBuscaInput"
              @focus="clienteDropdownAberto = true"
              autocomplete="off"
              placeholder="Buscar cliente..."
            />
            <div
              v-if="clienteDropdownAberto && clientes.length > 0"
              class="plano-contas-dropdown"
            >
              <div
                v-for="c in clientes.slice(0, 10)"
                :key="c.id_pessoa"
                class="plano-contas-option"
                @mousedown.prevent="selecionarCliente(c)"
              >
                <div class="d-flex justify-content-between">
                  <span class="font-weight-bold" style="font-size:12px">{{ c.nome }}</span>
                  <span class="text-muted" style="font-size:10px">{{ c.cnpj_cpf }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="clienteDropdownAberto && clienteBusca && clientes.length === 0"
              class="plano-contas-dropdown"
            >
              <div class="plano-contas-empty">Nenhum cliente encontrado.</div>
            </div>
          </div>
        </b-form-group>

        <b-form-group label="Plano de Contas" label-for="nl-plano" required>
          <div class="plano-contas-typeahead-modal" v-click-outside="fecharDropdownPlanoContasModal">
            <b-form-input
              id="nl-plano"
              v-model="planoContasModalBusca"
              @input="onPlanoContasModalBuscaInput"
              @focus="planoContasModalDropdownAberto = true"
              autocomplete="off"
              placeholder="Buscar ou selecionar plano de contas..."
              :state="novoLancamento.id_plano_contas ? true : null"
            />
            <div
              v-if="planoContasModalDropdownAberto && planosContasModalFiltrados.length > 0"
              class="plano-contas-dropdown"
            >
              <div
                v-for="p in planosContasModalFiltrados.slice(0, 10)"
                :key="p.id"
                class="plano-contas-option"
                @mousedown.prevent="selecionarPlanoContasModal(p)"
              >
                <span class="font-weight-bold" style="font-size:12px">{{ p.descricao }}</span>
              </div>
            </div>
            <div
              v-if="planoContasModalDropdownAberto && planoContasModalBusca && planosContasModalFiltrados.length === 0"
              class="plano-contas-dropdown"
            >
              <div class="plano-contas-empty">Nenhum plano encontrado.</div>
            </div>
            <b-form-invalid-feedback :state="novoLancamento.id_plano_contas ? true : null">
              Selecione um plano de contas.
            </b-form-invalid-feedback>
          </div>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { SistemaMixin } from "@/modules/Application";
import { parseOFX } from "../ofxParser";
import FileUpload from "vue-material-design-icons/FileUpload.vue";
import FileCheck from "vue-material-design-icons/FileCheck.vue";
import Check from "vue-material-design-icons/Check.vue";
import Refresh from "vue-material-design-icons/Refresh.vue";
import ArrowRight from "vue-material-design-icons/ArrowRight.vue";
import ArrowDownBold from "vue-material-design-icons/ArrowDownBold.vue";
import PlusCircle from "vue-material-design-icons/PlusCircle.vue";
import FilterVariant from "vue-material-design-icons/FilterVariant.vue";

export default {
  name: "app-conciliacao-bancaria-nova",
  mixins: [SistemaMixin],
  components: {
    FileUpload,
    FileCheck,
    Check,
    Refresh,
    ArrowRight,
    ArrowDownBold,
    PlusCircle,
    FilterVariant,
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = (event) => {
          if (!el.contains(event.target)) binding.value();
        };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      },
    },
  },
  data() {
    return {
      tabIndex: 0,
      isDragging: false,
      arquivoNome: "",
      arquivoOFX: null,
      isSaving: false,
      idConciliacao: null,
      isLoadingSistema: false,
      isConfirmandoLancamento: false,
      temMudancas: false, // ← Detecta alterações não salvas
      form: {
        id_banco: null,
      },
      bancos: [],
      bancoBusca: "",
      bancoDropdownAberto: false,
      ofxResumo: null,
      transacoes: [],
      lancamentosSistema: [],
      planosContas: [],
      planosContasFiltrados: {},
      isLoadingPlanos: false,
      planoContasBuscaAtual: {},
      planoContasDropdownAberto: {},
      lancamentoEditando: null,
      filtroLancamento: "",
      buscaLancamento: "",
      // filtros coluna sistema
      filtroSistemaTipo: "",
      filtroSistemaInicio: (() => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
      })(),
      filtroSistemaFim: (() => {
        const d = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      })(),
      // drag-and-drop
      draggedOfx: null,
      dropTargetSistema: null,
      // UI state
      showIgnorados: false,
      showConciliados: true,
      showFiltrosSistema: false,
      // Novo lançamento
      trnSelecionada: null,
      planosContasModal: [],
      planosContasModalFiltrados: [],
      planoContasModalBusca: "",
      planoContasModalDropdownAberto: false,
      // Fornecedor/Cliente para novo lançamento
      fornecedores: [],
      fornecedorBusca: "",
      fornecedorDropdownAberto: false,
      clientes: [],
      clienteBusca: "",
      clienteDropdownAberto: false,
      novoLancamento: {
        descricao: "",
        tipo: "S",
        data: "",
        valor: 0,
        id_plano_contas: null,
        id_pessoa: null,
      },
    };
  },
  computed: {

    conciliadosCount() {
      return this.transacoes.filter((t) => t.status === "conciliado").length;
    },
    percentualConcluido() {
      if (!this.transacoes.length) return 0;
      return Math.round((this.conciliadosCount / this.transacoes.length) * 100);
    },
    lancamentosOFXPendentes() {
      return this.transacoes
        .filter((t) => {
          const matchStatus = !this.filtroLancamento
            ? t.status === "pendente"
            : t.status === this.filtroLancamento;
          const matchBusca =
            !this.buscaLancamento ||
            (t.memo || "").toLowerCase().includes(this.buscaLancamento.toLowerCase());
          return matchStatus && matchBusca;
        })
        .sort((a, b) => (b._sugeridoSistema ? 1 : 0) - (a._sugeridoSistema ? 1 : 0));
    },
    transacoesIgnoradas() {
      return this.transacoes.filter((t) => t.status === "ignorado");
    },
    lancamentosSistemaDisponiveis() {
      return this.lancamentosSistema.filter((l) => {
        if (!this.filtroSistemaTipo) return true;
        return (l.tipo || "").toLowerCase().includes(this.filtroSistemaTipo.toLowerCase());
      });
    },
    paresConciliados() {
      const paresDoSistema = this.lancamentosSistema
        .filter((l) => l._conciliado)
        .map((l) => ({ ofx: l._conciliado, sistema: l }));

      // fitIds já cobertos pelos pares do sistema
      const fitIdsRepresentados = new Set(paresDoSistema.map((p) => p.ofx.fitId));

      // Transações conciliadas com id_lancamento_sistema mas cujo lançamento
      // não está na lista carregada (fora do período filtrado, por exemplo)
      const paresAusentes = this.transacoes
        .filter(
          (t) =>
            t.status === "conciliado" &&
            t.id_lancamento_sistema &&
            !fitIdsRepresentados.has(t.fitId)
        )
        .map((t) => ({
          ofx: t,
          sistema: {
            id: t.id_lancamento_sistema,
            descricao: `Lançamento #${t.id_lancamento_sistema}`,
            data: null,
            valor: t.trnAmt,
            tipo: t.trnAmt >= 0 ? "A Receber" : "A Pagar",
          },
        }));

      return [...paresDoSistema, ...paresAusentes];
    },
    // mantida para salvar
    lancamentosFiltrados() {
      return this.transacoes;
    },
    planosContasOptions() {
      return this.planosContas.map((p) => ({
        value: p.id,
        text: p.descricao,
      }));
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.temMudancas) {
      this.$bvModal.msgBoxConfirm(
        'Existem mudanças não salvas. Se sair agora, os lançamentos desconciliados ou marcados serão perdidos. Deseja realmente sair?',
        {
          title: 'Atenção!',
          okVariant: 'danger',
          okTitle: 'Sair sem salvar',
          cancelTitle: 'Continuar para salvar',
          centered: true,
        }
      ).then((value) => {
        if (value) {
          // Usuário clicou em "Sair sem salvar"
          next();
        }
        // Se cancelou, não chama next() e fica na página
      });
    } else {
      next();
    }
  },
  mounted() {
    const idConciliacao = this.$route.params.id;
    if (idConciliacao) {
      // Busca dados do backend pelo id
      this.fetchConciliacaoExistente(idConciliacao);
    } else {
      // Novo OFX: reseta para tab 0 (upload)
      this.tabIndex = 0;
    }
    // Avisar se tentar fechar a aba com mudanças não salvas
    window.addEventListener('beforeunload', this.onBeforeUnload);
  },
  beforeDestroy() {
    if (this._bancoBuscaTimer) clearTimeout(this._bancoBuscaTimer);
    if (this._planoContasBuscaTimer) clearTimeout(this._planoContasBuscaTimer);
    if (this._planoContasModalBuscaTimer) clearTimeout(this._planoContasModalBuscaTimer);
    if (this._fornecedorBuscaTimer) clearTimeout(this._fornecedorBuscaTimer);
    if (this._clienteBuscaTimer) clearTimeout(this._clienteBuscaTimer);
    if (this._sincronizandoTimer) clearTimeout(this._sincronizandoTimer);
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  },
  watch: {
    ofxResumo(val) {
      if (val && this.form.id_banco) {
        // Preenche datas do filtro com o período do OFX
        if (val.dtStart) {
          this.filtroSistemaInicio = this.formatarDataOFXParaInput(val.dtStart);
        }
        if (val.dtEnd) {
          this.filtroSistemaFim = this.formatarDataOFXParaInput(val.dtEnd);
        }
        // Busca automaticamente os lançamentos do sistema para o período
        this.fetchLancamentosSistema();
      }
    },
  },
  methods: {
    async fetchConciliacaoExistente(idConciliacao) {
      try {
        const { data } = await this.$http.post("/conciliacao-bancaria/detalhe", {
          id_conciliacao: idConciliacao,
        });
        const conciliacao = data.data ?? data;
        this.carregarConciliacaoExistente(conciliacao);
      } catch (err) {
        this.$toast.error("Erro ao carregar a conciliação.");
        this.$router.push({ name: 'conciliacaoBancariaLista' });
      }
    },
    carregarConciliacaoExistente(conciliacao) {
      // Carrega as transações OFX primeiro
      this.transacoes = (conciliacao.transacoes || []).map(t => ({
        ...t,
        _sugeridoSistema: t._sugeridoSistema ?? null,
        _confiancaSugestao: t._confiancaSugestao ?? 0,
        _sugestaoCompleta: t._sugestaoCompleta ?? null,
        _criarMovimentacao: false,
        _novoLancamento: null,
      }));
      
      // Usa data_inicio_ofx / data_fim_ofx do payload se disponível
      const dtStart = conciliacao.data_inicio_ofx || null;
      const dtEnd = conciliacao.data_fim_ofx || null;
      
      if (dtStart && dtEnd) {
        this.filtroSistemaInicio = dtStart;
        this.filtroSistemaFim = dtEnd;
      } else if (this.transacoes.length > 0) {
        // Fallback: deriva das transações convertendo dtPosted
        const datasStr = this.transacoes.map(t => this.formatarDataOFXParaInput(t.dtPosted)).filter(Boolean).sort();
        this.filtroSistemaInicio = datasStr[0];
        this.filtroSistemaFim = datasStr[datasStr.length - 1];
      }
      
      this.ofxResumo = {
        dtStart: this.filtroSistemaInicio,
        dtEnd: this.filtroSistemaFim,
        totalTransacoes: this.transacoes.length,
      };
      
      // Guarda o id para usar no update ao salvar
      this.idConciliacao = conciliacao.id_conciliacao || null;

      // Avança para tab 1 (Lançamentos)
      this.tabIndex = 1;
      
      // Trata o banco: pode vir id_banco direto ou só banco_nome
      const idBanco = conciliacao.id_banco;
      
      if (idBanco) {
        this.form.id_banco = idBanco;
        this.$nextTick(() => this.fetchLancamentosSistema());
      } else if (conciliacao.banco_nome) {
        // Busca o banco pelo nome para obter o id_banco
        this.fetchBancos(conciliacao.banco_nome).then(() => {
          const banco = this.bancos.find(b =>
            (b.nome || b.banco_nome || "").toLowerCase() === conciliacao.banco_nome.toLowerCase()
          );
          if (banco) {
            this.form.id_banco = banco.id_banco ?? banco.id;
            this.$nextTick(() => this.fetchLancamentosSistema());
          } else {
            console.warn("Banco não encontrado:", conciliacao.banco_nome);
          }
        });
      }
    },
    setActiveTab(event) {
      if (!this.form.id_banco) {
        const tab = event.target.getAttribute("data-tab");
        if (tab === "1") {
          this.$toast.warning("Selecione uma conta bancária antes de avançar.");
          event.preventDefault();
          return;
        }
      }
      const tab = event.target.getAttribute("data-tab");
      if (tab !== null) this.tabIndex = parseInt(tab);
    },
    avancarParaLancamentos() {
      if (!this.form.id_banco) {
        this.$toast.warning("Selecione uma conta bancária antes de avançar.");
        return;
      }
      this.tabIndex = 1;
    },
    // ─── Typeahead banco ─────────────────────────────────────────────────────
    onBancoBuscaInput() {
      this.form.id_banco = null;
      this.bancoDropdownAberto = true;
      if (this._bancoBuscaTimer) clearTimeout(this._bancoBuscaTimer);
      this._bancoBuscaTimer = setTimeout(() => {
        this.fetchBancos(this.bancoBusca);
      }, 300);
    },
    selecionarBanco(banco) {
      this.form.id_banco = banco.id_banco;
      this.bancoBusca = banco.nome;
      this.bancoDropdownAberto = false;
      if (this.ofxResumo) this.fetchLancamentosSistema();
    },
    limparBanco() {
      this.form.id_banco = null;
      this.bancoBusca = "";
      this.bancoDropdownAberto = false;
    },
    fecharDropdownBanco() {
      this.bancoDropdownAberto = false;
      // Se digitou mas não selecionou um item válido, limpa o campo
      if (this.bancoBusca && !this.form.id_banco) {
        this.bancoBusca = "";
      }
    },
    async fetchBancos(nome = "") {
      try {
        const { data } = await this.$http.post("/bancos/buscar", { nome });
        // aceita array direto ou { data: [...] }
        this.bancos = Array.isArray(data) ? data : (data.data ?? []);
      } catch {
        this.$toast.error("Erro ao carregar as contas bancárias.");
      }
    },
    async fetchPlanosContas() {
      this.isLoadingPlanos = true;
      try {
        // Buscar todos os planos independente do tipo
        const lista = await this.getPlanoContasFinanceiro(null, "");
        this.planosContas = Array.isArray(lista) ? lista : (lista.data ?? []);
        
        // Adicionar planos específicos de cada lançamento à lista principal
        this.lancamentosSistema.forEach((lan) => {
          if (lan.plano_contas && !this.planosContas.find(p => p.id === lan.plano_contas.id)) {
            this.planosContas.push(lan.plano_contas);
          }
        });
      } catch (err) {
        console.error("Erro ao carregar planos de contas:", err);
        this.planosContas = [];
      } finally {
        this.isLoadingPlanos = false;
      }
    },
    async fetchPlanoContasSearch(lanId, descricao, tipo = null) {
      try {
        // Se tipo não foi passado, buscar todos
        const lista = await this.getPlanoContasFinanceiro(tipo, descricao);
        const resultados = Array.isArray(lista) ? lista : (lista.data ?? []);
        this.$set(this.planosContasFiltrados, lanId, resultados);
        
        // Adicionar resultados da busca à lista principal de planosContas
        resultados.forEach((plano) => {
          if (!this.planosContas.find(p => p.id === plano.id)) {
            this.planosContas.push(plano);
          }
        });
      } catch (err) {
        console.error("Erro ao buscar planos de contas:", err);
        this.$set(this.planosContasFiltrados, lanId, []);
      }
    },
    onPlanoContasBuscaInput(lancamento, searchValue) {
      this.lancamentoEditando = lancamento;
      this.$set(this.planoContasDropdownAberto, lancamento.id, true);
      // Armazenar o valor de busca por lançamento
      this.$set(this.planoContasBuscaAtual, lancamento.id, searchValue);
      
      // Determinar tipo: 1 = Despesa (A Pagar), 2 = Receita (A Receber)
      const tipoStr = (lancamento.tipo || '').toLowerCase();
      const tipoPlano = (tipoStr.includes('receita') || tipoStr.includes('receber')) ? 2 : 1;
      
      if (this._planoContasBuscaTimer) clearTimeout(this._planoContasBuscaTimer);
      if (searchValue && searchValue.trim()) {
        this._planoContasBuscaTimer = setTimeout(() => {
          this.fetchPlanoContasSearch(lancamento.id, searchValue, tipoPlano);
        }, 300);
      } else {
        // Se campo vazio, carregar todos do tipo específico do lançamento
        this.fetchPlanoContasSearch(lancamento.id, "", tipoPlano);
      }
    },
    fecharDropdownPlanoContas(lanId) {
      if (lanId) {
        this.$set(this.planoContasDropdownAberto, lanId, false);
      } else {
        this.planoContasDropdownAberto = {};
      }
    },
    async fetchPlanoContasByTipo(tipo, descricao = "") {
      try {
        // tipo: 1 = Conta a Pagar (Despesa), 2 = Conta a Receber (Receita)
        const tipoPlano = tipo === "E" ? 2 : 1;
        const lista = await this.getPlanoContasFinanceiro(tipoPlano, descricao);
        this.planosContasModal = Array.isArray(lista) ? lista : (lista.data ?? []);
        this.planosContasModalFiltrados = this.planosContasModal;
      } catch (err) {
        console.error("Erro ao carregar planos de contas por tipo:", err);
        this.planosContasModal = [];
        this.planosContasModalFiltrados = [];
      }
    },
    onPlanoContasModalBuscaInput() {
      this.planoContasModalDropdownAberto = true;
      if (this._planoContasModalBuscaTimer) clearTimeout(this._planoContasModalBuscaTimer);
      if (this.planoContasModalBusca.trim()) {
        this._planoContasModalBuscaTimer = setTimeout(() => {
          this.fetchPlanoContasByTipo(this.novoLancamento.tipo, this.planoContasModalBusca);
        }, 300);
      } else {
        this.planosContasModalFiltrados = this.planosContasModal;
      }
    },
    fecharDropdownPlanoContasModal() {
      this.planoContasModalDropdownAberto = false;
    },
    selecionarPlanoContasModal(plano) {
      this.novoLancamento.id_plano_contas = plano.id;
      this.planoContasModalBusca = plano.descricao;
      this.planoContasModalDropdownAberto = false;
    },
    // ─── Typeahead fornecedor ────────────────────────────────────────────
    onFornecedorBuscaInput() {
      this.fornecedorDropdownAberto = true;
      if (this._fornecedorBuscaTimer) clearTimeout(this._fornecedorBuscaTimer);
      if (this.fornecedorBusca.trim()) {
        this._fornecedorBuscaTimer = setTimeout(() => {
          this.fetchFornecedores(this.fornecedorBusca);
        }, 300);
      } else {
        this.fornecedores = [];
      }
    },
    async fetchFornecedores(nome) {
      try {
        this.fornecedores = await this.getFornecedores(nome);
      } catch (err) {
        console.error("Erro ao buscar fornecedores:", err);
        this.fornecedores = [];
      }
    },
    selecionarFornecedor(fornecedor) {
      this.novoLancamento.id_pessoa = fornecedor.id_pessoa;
      this.fornecedorBusca = fornecedor.nome;
      this.fornecedorDropdownAberto = false;
    },
    fecharDropdownFornecedor() {
      this.fornecedorDropdownAberto = false;
    },
    // ─── Typeahead cliente ───────────────────────────────────────────────
    onClienteBuscaInput() {
      this.clienteDropdownAberto = true;
      if (this._clienteBuscaTimer) clearTimeout(this._clienteBuscaTimer);
      if (this.clienteBusca.trim()) {
        this._clienteBuscaTimer = setTimeout(() => {
          this.fetchClientes(this.clienteBusca);
        }, 300);
      } else {
        this.clientes = [];
      }
    },
    async fetchClientes(nome) {
      try {
        this.clientes = await this.getClientes(nome);
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
        this.clientes = [];
      }
    },
    selecionarCliente(cliente) {
      this.novoLancamento.id_pessoa = cliente.id_pessoa;
      this.clienteBusca = cliente.nome;
      this.clienteDropdownAberto = false;
    },
    fecharDropdownCliente() {
      this.clienteDropdownAberto = false;
    },
    async fetchLancamentosSistema() {
      this.isLoadingSistema = true;
      // Preservar pares já conciliados para não perder ao recarregar
      const conciliadosMap = {};
      this.lancamentosSistema.forEach((l) => {
        if (l._conciliado) conciliadosMap[l.id] = l._conciliado;
      });
      try {
        const { data } = await this.$http.post("/conciliacao-bancaria/lancamentos-sistema", {
          id_banco: this.form.id_banco,
          data_inicio: this.filtroSistemaInicio,
          data_fim: this.filtroSistemaFim,
          tipo: this.filtroSistemaTipo || null,
        });
        const lista = Array.isArray(data) ? data : (data.data ?? []);
        // Mapa das transações OFX que já vieram com status "conciliado" do backend
        const conciliadosPorIdSistema = {};
        this.transacoes.forEach((t) => {
          if (t.status === "conciliado" && t.id_lancamento_sistema) {
            conciliadosPorIdSistema[t.id_lancamento_sistema] = t;
          }
        });
        this.lancamentosSistema = lista.map((l) => ({
          ...l,
          _conciliado: conciliadosMap[l.id] ?? conciliadosPorIdSistema[l.id] ?? null,
        }));
        // Buscar sugestões automáticas após carregar lançamentos
        this.buscarSugestoesAutomaticas();
        // Buscar planos de contas
        this.fetchPlanosContas();
      } catch (err) {
        // Silenciosamente log o erro sem mostrar toast
        console.error("Erro ao carregar lançamentos do sistema:", err);
      } finally {
        this.isLoadingSistema = false;
      }
    },
    async buscarSugestoesAutomaticas() {
      if (!this.transacoes.length || !this.lancamentosSistema.length) return;
      try {
        const { data } = await this.$http.post("/conciliacao-bancaria/sugerir-correspondencias", {
          id_banco: this.form.id_banco,
          transacoes_ofx: this.transacoes,
          lancamentos_sistema: this.lancamentosSistema,
        });
        // Aceita múltiplos formatos de resposta:
        // 1. Array direto: [...]
        // 2. Objeto com sugestoes: { sugestoes: [...] }
        // 3. Objeto com data.sugestoes: { data: { sugestoes: [...] } }
        const sugestoes = Array.isArray(data) 
          ? data 
          : (data.sugestoes ?? data.data?.sugestoes ?? []);
        
        // Atualizar transações OFX com sugestões usando this.$set para reatividade
        this.transacoes.forEach((trn, idx) => {
          const sug = sugestoes.find((s) => s.fitId_ofx === trn.fitId);
          if (sug) {
            // Usar $set para garantir reatividade
            this.$set(this.transacoes[idx], '_sugeridoSistema', sug.id_sistema);
            this.$set(this.transacoes[idx], '_confiancaSugestao', sug.confianca);
            // Armazenar também o objeto da sugestão completa
            this.$set(this.transacoes[idx], '_sugestaoCompleta', sug);
          }
        });
        
        // Atualizar lançamentos do sistema com referência ao OFX sugerido
        this.lancamentosSistema.forEach((lan, idx) => {
          const sug = sugestoes.find((s) => s.id_sistema === lan.id);
          if (sug) {
            // Usa $set para garantir reatividade
            this.$set(this.lancamentosSistema[idx], '_sugeridoOfx', sug.fitId_ofx);
            this.$set(this.lancamentosSistema[idx], '_confiancaSugestaoOfx', sug.confianca);
            this.$set(this.lancamentosSistema[idx], '_sugestaoCompleta', sug);
            
            // Se a sugestão trouxer plano de contas, pré-selecionar
            if (sug.id_plano_contas) {
              this.$set(this.lancamentosSistema[idx], 'id_plano_contas', sug.id_plano_contas);
              const planoSelecionado = this.planosContas.find((p) => p.id === sug.id_plano_contas);
              if (planoSelecionado) {
                this.$set(this.lancamentosSistema[idx], 'plano_contas', {
                  id: planoSelecionado.id,
                  descricao: planoSelecionado.descricao,
                  tipo: planoSelecionado.tipo,
                });
              }
            }
          }
        });
        
        console.log("Sugestões carregadas:", sugestoes);
      } catch (err) {
        // Silenciosamente log o erro
        console.error("Erro ao buscar sugestões automáticas:", err);
      }
    },
    onFileDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      if (file) this.processarArquivo(file);
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) this.processarArquivo(file);
    },
    processarArquivo(file) {
      const name = file.name.toLowerCase();
      if (!name.endsWith(".ofx")) {
        this.$toast.error("Arquivo inválido. Selecione um arquivo .ofx");
        return;
      }
      this.arquivoNome = file.name;
      this.arquivoOFX = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const { resumo, transacoes } = parseOFX(e.target.result);
          this.ofxResumo = resumo;
          this.transacoes = transacoes.map((t) => ({
            ...t,
            status: "pendente",
            _sugeridoSistema: null,
            _confiancaSugestao: 0,
            _criarMovimentacao: false,
            _novoLancamento: null,
          }));
          if (this.transacoes.length > 0) {
            this.$toast.success(`${this.transacoes.length} lançamentos carregados!`);
          } else {
            this.$toast.warning("Nenhum lançamento encontrado no arquivo OFX.");
          }
        } catch (err) {
          this.$toast.error("Erro ao processar o arquivo OFX. Verifique o formato.");
          console.error(err);
        }
      };
      reader.readAsText(file, "UTF-8");
    },
    // ─── Drag and Drop ───────────────────────────────────────────────────────
    onDragStart(trn, event) {
      this.draggedOfx = trn;
      event.dataTransfer.effectAllowed = "link";
    },
    onDragEnd() {
      this.draggedOfx = null;
      this.dropTargetSistema = null;
    },
    onDrop(lancamentoSistema) {
      this.dropTargetSistema = null;
      if (!this.draggedOfx) return;
      // Verificar se o lançamento do sistema já está conciliado
      if (lancamentoSistema._conciliado) {
        this.$toast.warning("Este lançamento já está conciliado. Desfaça primeiro.");
        return;
      }
      // Conciliar
      this.$set(lancamentoSistema, "_conciliado", this.draggedOfx);
      this.draggedOfx.status = "conciliado";
      this.draggedOfx = null;
      this.temMudancas = true; // ← Marca como alterado
      this.$toast.success("Registros conciliado com sucesso!");
      this.sincronizarComBackend();
    },
    desfazerConciliacao(lancamentoSistema) {
      if (!lancamentoSistema._conciliado) return;
      lancamentoSistema._conciliado.status = "pendente";
      this.$set(lancamentoSistema, "_conciliado", null);
      this.temMudancas = true; // ← Marca como alterado
      this.sincronizarComBackend();
    },
    desfazerPar(par) {
      // Par com lançamento do sistema carregado na lista
      if (par.sistema._conciliado !== undefined) {
        this.desfazerConciliacao(par.sistema);
      } else {
        // Par "ausente": lançamento do sistema fora do período filtrado
        this.$set(par.ofx, "status", "pendente");
        this.$set(par.ofx, "id_lancamento_sistema", null);
        this.temMudancas = true; // ← Marca como alterado
        this.sincronizarComBackend();
      }
    },
    // ─── Helpers ─────────────────────────────────────────────────────────────
    formatarDataOFXParaInput(dataOFX) {
      if (!dataOFX) return "";
      const str = String(dataOFX).trim();
      
      // Tenta detectar padrão YYYY-MM-DD
      const padrao1 = /(\d{4})-(\d{1,2})-(\d{1,2})/;
      const match1 = str.match(padrao1);
      if (match1) {
        return `${match1[1]}-${String(match1[2]).padStart(2, '0')}-${String(match1[3]).padStart(2, '0')}`;
      }
      
      // Tenta detectar ouro padrão com caracteres extras: YYYY--MM-DD- ou similar
      const padrao2 = /(\d{4})\D+(\d{1,2})\D+(\d{1,2})/;
      const match2 = str.match(padrao2);
      if (match2) {
        return `${match2[1]}-${String(match2[2]).padStart(2, '0')}-${String(match2[3]).padStart(2, '0')}`;
      }
      
      // Fallback: pega apenas dígitos
      const digitos = str.replace(/\D/g, "");
      if (digitos.length >= 8) {
        return `${digitos.slice(0, 4)}-${digitos.slice(4, 6)}-${digitos.slice(6, 8)}`;
      }
      
      return "";
    },
    // ─── Ações individuais OFX ───────────────────────────────────────────────
    marcarConciliado(trn) {
      trn.status = "conciliado";
      this.temMudancas = true; // ← Marca como alterado
    },
    marcarIgnorado(trn) {
      trn.status = "ignorado";
      this.temMudancas = true; // ← Marca como alterado
    },
    marcarPendente(trn) {
      trn.status = "pendente";
      this.temMudancas = true; // ← Marca como alterado
    },
    alterarPlanoConta(lancamento, newPlanId) {
      const planSelecionado = this.planosContas.find((p) => p.id === newPlanId);
      if (planSelecionado) {
        this.$set(lancamento, "id_plano_contas", newPlanId);
        this.$set(lancamento, "plano_contas", {
          id: planSelecionado.id,
          descricao: planSelecionado.descricao,
          tipo: planSelecionado.tipo,
        });
        // Determinar tipo para enviar ao backend: 1 = Despesa, 2 = Receita
        const tipoBackend = lancamento.tipo && (lancamento.tipo.toLowerCase().includes('receita') || lancamento.tipo.toLowerCase().includes('receber')) ? 2 : 1;
        this.$set(lancamento, "tipo_plano_contas", tipoBackend);
        this.temMudancas = true; // ← Marca como alterado
      }
    },
    // ─── Sincronização automática ────────────────────────────────────────────
    async _executarSincronizacao() {
      if (!this.form.id_banco || !this.transacoes.length) return;
      const pares = this.lancamentosSistema
        .filter((l) => l._conciliado)
        .map((l) => ({
          ofx: l._conciliado,
          id_lancamento_sistema: l.id,
        }));

      const novasMovimentacoes = this.transacoes
        .filter((t) => t._criarMovimentacao && t._novoLancamento)
        .map((t) => ({
          ...t._novoLancamento,
          fitId: t.fitId,
        }));

      const lancamentosSistemaComTipo = this.lancamentosSistema.map((lan) => ({
        ...lan,
        tipo_plano_contas:
          lan.tipo &&
          (lan.tipo.toLowerCase().includes('receita') ||
            lan.tipo.toLowerCase().includes('receber'))
            ? 2
            : 1,
      }));

      const endpoint = this.idConciliacao
        ? "/conciliacao-bancaria/atualizar"
        : "/conciliacao-bancaria/salvar";

      const payload = {
        ...(this.idConciliacao ? { id_conciliacao: this.idConciliacao } : {}),
        id_banco: this.form.id_banco,
        resumo: this.ofxResumo,
        transacoes: this.transacoes,
        lancamentos_sistema: lancamentosSistemaComTipo,
        pares,
        total_lancamentos: this.transacoes.length,
        total_conciliados: this.conciliadosCount,
        percentual: this.percentualConcluido,
        novas_movimentacoes: novasMovimentacoes,
      };

      let response;
      if (this.arquivoOFX && !this.idConciliacao) {
        const formData = new FormData();
        formData.append("arquivo_ofx", this.arquivoOFX);
        Object.keys(payload).forEach((key) => {
          formData.append(key, JSON.stringify(payload[key]));
        });
        response = await this.$http.post(endpoint, formData);
      } else {
        response = await this.$http.post(endpoint, payload);
      }

      // Se era uma nova conciliação, armazena o id retornado para as próximas sincronizações
      if (!this.idConciliacao) {
        const retorno = response.data?.data ?? response.data;
        if (retorno?.id_conciliacao) {
          this.idConciliacao = retorno.id_conciliacao;
        }
      }
    },
    sincronizarComBackend() {
      if (!this.form.id_banco || !this.transacoes.length) return;
      if (this._sincronizandoTimer) clearTimeout(this._sincronizandoTimer);
      // Debounce de 400ms para evitar múltiplas chamadas em sequência
      this._sincronizandoTimer = setTimeout(() => {
        this._executarSincronizacao().catch((err) => {
          console.error("Erro ao sincronizar conciliação com o backend:", err);
        });
      }, 400);
    },
    // ─── Salvar ──────────────────────────────────────────────────────────────
    async salvarConciliacao() {
      if (!this.form.id_banco) {
        this.$toast.error("Selecione uma conta bancária.");
        this.tabIndex = 0;
        return;
      }
      if (!this.transacoes.length) {
        this.$toast.error("Nenhum lançamento para salvar.");
        return;
      }
      this.isSaving = true;
      try {
        // Montar pares conciliados com referência ao lançamento do sistema
        const pares = this.lancamentosSistema
          .filter((l) => l._conciliado)
          .map((l) => ({
            ofx: l._conciliado,
            id_lancamento_sistema: l.id,
          }));

        const endpoint = this.idConciliacao
          ? "/conciliacao-bancaria/atualizar"
          : "/conciliacao-bancaria/salvar";

        const novasMovimentacoes = this.transacoes
          .filter((t) => t._criarMovimentacao && t._novoLancamento)
          .map((t) => ({
            ...t._novoLancamento,
            fitId: t.fitId  // ← Adiciona o fitId da transação OFX para conciliação automática
          }));

        // Preparar lancamentos_sistema com tipo_plano_contas
        const lancamentosSistemaComTipo = this.lancamentosSistema.map((lan) => ({
          ...lan,
          tipo_plano_contas: lan.tipo && (lan.tipo.toLowerCase().includes('receita') || lan.tipo.toLowerCase().includes('receber')) ? 2 : 1,
        }));

        const payload = {
          ...(this.idConciliacao ? { id_conciliacao: this.idConciliacao } : {}),
          id_banco: this.form.id_banco,
          resumo: this.ofxResumo,
          transacoes: this.transacoes,
          lancamentos_sistema: lancamentosSistemaComTipo,
          pares,
          total_lancamentos: this.transacoes.length,
          total_conciliados: this.conciliadosCount,
          percentual: this.percentualConcluido,
          novas_movimentacoes: novasMovimentacoes,
        };

        // Enviar como multipart/form-data se houver arquivo OFX
        if (this.arquivoOFX) {
          const formData = new FormData();
          formData.append("arquivo_ofx", this.arquivoOFX);
          // Adicionar os demais campos como JSON string
          Object.keys(payload).forEach((key) => {
            formData.append(key, JSON.stringify(payload[key]));
          });
          // Não especificar Content-Type - Axios detecta FormData automaticamente
          await this.$http.post(endpoint, formData);
        } else {
          // Conciliação existente sem arquivo novo - enviar como JSON
          await this.$http.post(endpoint, payload);
        }

        this.$toast.success("Conciliação salva com sucesso!");
        this.temMudancas = false; // ← Reseta o indicador de mudanças
        this.$router.push({ name: "conciliacaoBancariaLista" });
      } catch {
        this.$toast.error("Erro ao salvar a conciliação.");
      } finally {
        this.isSaving = false;
      }
    },
    // ─── Helpers ─────────────────────────────────────────────────────────────
    formatDate(dateStr) {
      if (!dateStr) return "-";
      
      const s = String(dateStr).trim();
      
      // Tenta padrão ISO: 2026-01-01 ou 2026-01-01T00:00:00Z
      // Evita new Date("YYYY-MM-DD") que interpreta como UTC meia-noite e retorna -1 dia no BRT
      const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
      }
      
      // Fallback: OFX raw YYYYMMDD
      const digitos = s.replace(/\D/g, "");
      if (digitos.length >= 8) {
        const year = digitos.slice(0, 4);
        const month = digitos.slice(4, 6);
        const day = digitos.slice(6, 8);
        return `${day}/${month}/${year}`;
      }
      
      return dateStr;
    },
    getProgressVariant(percent) {
      if (percent >= 100) return "success";
      if (percent >= 50) return "warning";
      return "danger";
    },
    getTextVariant(percent) {
      if (percent >= 100) return "text-success";
      if (percent >= 50) return "text-warning";
      return "text-danger";
    },
    getRowClass(status) {
      if (status === "conciliado") return "table-success";
      if (status === "ignorado") return "table-secondary";
      return "";
    },
    getTipoClass(tipo) {
      if (["CREDIT", "DEP", "INT", "DIRECTDEP"].includes(tipo)) return "badge badge-success";
      return "badge badge-danger";
    },
    getTipoLabel(tipo) {
      const map = {
        DEBIT: "Débito", CREDIT: "Crédito", INT: "Juros", DIV: "Dividendo",
        FEE: "Tarifa", SRVCHG: "Serviço", DEP: "Depósito", ATM: "ATM",
        POS: "POS", XFER: "Transferência", CHECK: "Cheque", PAYMENT: "Pagamento",
        CASH: "Saque", DIRECTDEP: "Dep. Direto", DIRECTDEBIT: "Déb. Direto",
        REPEATPMT: "Recorrente", OTHER: "Outro",
      };
      return map[tipo] || tipo || "-";
    },
    getStatusBadge(status) {
      if (status === "conciliado") return "badge badge-success";
      if (status === "ignorado") return "badge badge-secondary";
      return "badge badge-warning";
    },
    getStatusLabel(status) {
      if (status === "conciliado") return "Conciliado";
      if (status === "ignorado") return "Ignorado";
      return "Pendente";
    },
    getValorClassPorTipo(tipo) {
      const tipoLower = (tipo || "").toLowerCase();
      if (tipoLower.includes("receber") || tipoLower.includes("receita")) {
        return "text-success";
      }
      return "text-danger";
    },
    async abrirModalNovoLancamento(trn) {
      this.trnSelecionada = trn;
      const tipo = trn.trnAmt >= 0 ? "E" : "S";
      this.novoLancamento = {
        descricao: trn.memo || "",
        tipo: tipo,
        data: trn.dtPosted
          ? this.formatarDataOFXParaInput(trn.dtPosted)
          : (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })(),
        valor: Math.abs(trn.trnAmt),
        id_plano_contas: null,
        id_pessoa: null,
      };
      this.planoContasModalBusca = "";
      this.planoContasModalDropdownAberto = false;
      this.fornecedorBusca = "";
      this.fornecedorDropdownAberto = false;
      this.fornecedores = [];
      this.clienteBusca = "";
      this.clienteDropdownAberto = false;
      this.clientes = [];
      // Buscar planos de contas conforme o tipo
      await this.fetchPlanoContasByTipo(tipo);
      this.$bvModal.show("modal-novo-lancamento-create");
    },
    async confirmarNovoLancamento(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault(); // impede fechar até terminar
      if (!this.trnSelecionada) return;
      if (!this.novoLancamento.id_plano_contas) {
        this.$toast.warning("Selecione um plano de contas.");
        return;
      }
      this.isConfirmandoLancamento = true;
      const trnParaCriar = this.trnSelecionada;
      this.$set(trnParaCriar, "_criarMovimentacao", true);
      this.$set(trnParaCriar, "_novoLancamento", { ...this.novoLancamento });
      this.temMudancas = true;
      this.trnSelecionada = null;
      try {
        await this._executarSincronizacao();
        // Recarrega a conciliação completa do backend para mostrar
        // o novo lançamento criado e conciliado na coluna Sistema e nos pares
        if (this.idConciliacao) {
          await this.fetchConciliacaoExistente(this.idConciliacao);
        } else {
          await this.fetchLancamentosSistema();
        }
        this.$toast.success("Lançamento criado e conciliado com sucesso!");
      } catch (err) {
        console.error("Erro ao confirmar novo lançamento:", err);
        this.$toast.error("Erro ao salvar o lançamento.");
        // Reverte a marcação em caso de erro
        this.$set(trnParaCriar, "_criarMovimentacao", false);
        this.$set(trnParaCriar, "_novoLancamento", null);
      } finally {
        this.isConfirmandoLancamento = false;
        this.$bvModal.hide("modal-novo-lancamento-create");
      }
    },
    cancelarNovoLancamento(trn) {
      this.$set(trn, "_criarMovimentacao", false);
      this.$set(trn, "_novoLancamento", null);
      this.temMudancas = true; // ← Marca como alterado
      this.sincronizarComBackend();
    },
    // Aviso ao tentar fechar a aba com mudanças não salvas
    onBeforeUnload(event) {
      if (this.temMudancas) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    },
  },
};
</script>

<style scoped>
/* ── Typeahead banco ───────────────────────────────────────────────── */
.banco-typeahead {
  position: relative;
}
.banco-typeahead__dropdown {
  position: absolute;
  z-index: 1050;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #d5d5d5;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 220px;
  overflow-y: auto;
}
.banco-typeahead__option {
  padding: 8px 14px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.1s;
}
.banco-typeahead__option:hover {
  background: #f0f7ff;
}
.banco-typeahead__empty {
  padding: 10px 14px;
  font-size: 13px;
  color: #aaa;
}

/* ── Typeahead plano de contas ─────────────────────────────────────── */
.plano-contas-typeahead,
.plano-contas-typeahead-modal {
  position: relative;
}
.plano-contas-dropdown {
  position: absolute;
  z-index: 1050;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #d5d5d5;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 250px;
  overflow-y: auto;
}
.plano-contas-option {
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.1s;
  border-bottom: 1px solid #f0f0f0;
}
.plano-contas-option:last-child {
  border-bottom: none;
}
.plano-contas-option:hover {
  background: #f0f9f0;
}
.plano-contas-empty {
  padding: 10px 14px;
  font-size: 13px;
  color: #aaa;
  text-align: center;
}

/* ── Dropzone OFX upload ───────────────────────────────────────────── */
.ofx-dropzone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px 20px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  background-color: #fafafa;
}
.ofx-dropzone:hover,
.ofx-dropzone--active {
  border-color: #3699ff;
  background-color: #e8f3ff;
}

/* ── Grid duas colunas ─────────────────────────────────────────────── */
.conciliacao-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}
@media (max-width: 768px) {
  .conciliacao-grid { grid-template-columns: 1fr; }
}

/* ── Coluna genérica ───────────────────────────────────────────────── */
.conc-col {
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.conc-col-header {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  font-size: 13px;
  color: #fff;
}
.conc-col-header--ofx {
  background: #1b84ff;
}
.conc-col-header--sistema {
  background: #50cd89;
}
.conc-col-body {
  padding: 6px;
  max-height: 700px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

/* ── Card OFX (arrastar) ───────────────────────────────────────────── */
.ofx-card {
  border: 1px solid #d5e8ff;
  border-radius: 4px;
  padding: 4px 6px;
  background: #f5f9ff;
  cursor: grab;
  transition: box-shadow 0.15s, opacity 0.15s, background-color 0.15s, border-color 0.15s;
  user-select: none;
}
.ofx-card:hover {
  box-shadow: 0 2px 8px rgba(27, 132, 255, 0.18);
  border-color: #1b84ff;
}
.ofx-card--sugerido {
  background-color: #fffacd;
  border-color: #ffc107;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.25);
}
.ofx-card--dragging {
  opacity: 0.4;
}
.ofx-card--ignored {
  background: #f5f5f5;
  border-color: #ddd;
  cursor: default;
  opacity: 0.75;
}
.ofx-card__memo {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.ofx-card__drag-hint {
  font-size: 8px;
  color: #1b84ff;
  margin-top: 3px;
  display: flex;
  align-items: center;
}

/* ── Painel de filtros do sistema ──────────────────────────────────── */
.sistema-filtros {
  padding: 6px 8px;
  background: #f0fff8;
  border-bottom: 1px solid #b5edce;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  to {
    opacity: 1;
    max-height: 100px;
    padding-top: 6px;
    padding-bottom: 6px;
  }
}

/* ── Card Sistema (drop target) ────────────────────────────────────── */
.sistema-card {
  border: 2px solid #e4e6ef;
  border-radius: 4px;
  padding: 4px 6px;
  background: #f9f9f9;
  transition: border-color 0.15s, background 0.15s;
  position: relative;
}
/* Card ganha z-index maior quando tem foco dentro (dropdown aberto) */
.sistema-card:focus-within {
  z-index: 100;
}
.sistema-card--over {
  border-color: #50cd89;
  background: #eefff6;
  box-shadow: 0 0 0 3px rgba(80, 205, 137, 0.2);
}
.sistema-card--conciliado {
  border-color: #50cd89;
  background: #f0fff8;
}
.sistema-card__drop-hint {
  font-size: 8px;
  color: #50cd89;
  font-weight: bold;
  margin-top: 3px;
  display: flex;
  align-items: center;
}

/* ── Resumo de pares conciliados ───────────────────────────────────── */
.conciliados-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.conciliado-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f0fff8;
  border: 1px solid #b5edce;
  border-radius: 6px;
  padding: 8px 12px;
}
.conciliado-row__ofx,
.conciliado-row__sis {
  flex: 1;
  min-width: 0;
}
.conciliado-row__arrow {
  font-size: 16px;
  color: #50cd89;
  flex-shrink: 0;
}

/* ── Typeahead fornecedor/cliente no modal ─────────────────────────── */
.fornecedor-typeahead-modal,
.cliente-typeahead-modal,
.plano-contas-typeahead-modal {
  position: relative;
}
</style>
